const tpl = (fields) => ({ page: 'triggers', ...fields })

export const TRIGGER_TEMPLATES_PART01 = [
  tpl({
    id: 'demo-tpl-trg-lead-to-crm',
    title: 'Lead email to CRM',
    category: 'Sales',
    when: { app: 'Gmail', event: 'New email received' },
    apps: ['Gmail', 'HubSpot', 'Slack'],
    description: 'Every new lead that emails you lands in HubSpot with a deal and a heads-up in Slack.',
    steps: [
      'Spot emails from people not yet in HubSpot asking about pricing or a demo',
      'Create the contact and a deal in the first stage',
      'Post who it is and what they asked to #sales',
    ],
    prompt:
      'When a new email arrives in Gmail from someone who is not in HubSpot and asks about pricing or a demo, create the contact and a deal in HubSpot and post a summary to Slack #sales.',
  }),
  tpl({
    id: 'demo-tpl-trg-escalation',
    title: 'Customer escalation alert',
    category: 'Ops',
    when: { app: 'Gmail', event: 'New email received' },
    apps: ['Gmail', 'Slack'],
    description: 'Urgent customer emails reach the right channel in seconds instead of sitting in an inbox.',
    steps: [
      'Watch for customer emails mentioning an outage, data loss, or “urgent”',
      'Summarise the problem and who is affected',
      'Alert #support-escalations with a link to the thread',
    ],
    prompt:
      'When an email arrives from a customer domain mentioning an outage, data loss, or the word urgent, summarise the issue and post an alert to Slack #support-escalations with a link to the thread.',
  }),
  tpl({
    id: 'demo-tpl-trg-deal-enrich',
    title: 'Enrich new deals',
    category: 'Sales',
    when: { app: 'HubSpot', event: 'Deal created' },
    apps: ['HubSpot', 'Web research'],
    description: 'Every new deal gets a research note before the first call.',
    steps: ['Research the company’s size, funding, and recent news', 'Note likely priorities and competitors', 'Add the summary as a note on the deal'],
    prompt:
      'When a new deal is created in HubSpot, research the company (size, funding, tech stack, recent news) and add a short summary note to the deal.',
  }),
]
